export default {
  title: 'Tables',
  count_one: '{{count}} table',
  count_other: '{{count}} tables',
  filtered_count: '{{shown}} sur {{count}} tables',
  intro:
    'Chaque table a son propre lien et son propre QR code. Les clients qui le scannent commandent pour cette table, et vous voyez la table sur chaque commande.',
  migrated: {
    title: 'Le service en chambre/à table devient Commande à table',
    description:
      'Nous avons ajouté une table pour chacun de vos établissements, à son nom, afin que les clients puissent continuer à commander. Renommez-les selon vos tables, ou ajoutez-en d’autres.',
  },
  add: {
    label: 'Ajouter une table',
    placeholder: 'ex. 7, 1A ou Terrasse 2',
    button: 'Ajouter la table',
  },
  errors: {
    empty: 'Saisissez un nom de table.',
    duplicate: 'Il existe déjà une table nommée « {{name}} ».',
    too_long: 'Un nom de table peut contenir jusqu’à {{max}} caractères.',
  },
  columns: {
    order: 'Ordre',
    table: 'Table et lien',
    on: 'Activée',
    copy: 'Copier le lien',
    qr: 'QR code',
    actions: 'Actions',
  },
  switch: {
    on: 'Activée',
    off: 'Désactivée',
  },
  buttons: {
    copy: 'Copier le lien',
    copied: 'Copié',
    download_qr: 'Télécharger le QR code',
    qr_short: 'QR code',
    rename: 'Renommer',
    delete: 'Supprimer',
    save: 'Enregistrer',
    cancel: 'Annuler',
  },
  aria: {
    move: 'Déplacer {{name}} (touches fléchées)',
    switch: '{{name}} activée',
    copy: 'Copier le lien de {{name}}',
    copied: 'Lien copié',
    download_qr: 'Télécharger le QR code de {{name}}',
    rename: 'Renommer {{name}}',
    delete: 'Supprimer {{name}}',
    more: 'Plus d’options pour {{name}}',
    new_name: 'Nouveau nom pour {{name}}',
  },
  tooltips: {
    move: 'Glisser pour réordonner',
    move_disabled: 'Effacez la recherche pour réordonner',
  },
  rename_hint: 'Le lien et le QR code restent identiques.',
  no_link: 'Pas encore d’adresse de boutique',
  search: {
    placeholder: 'Rechercher des tables',
    no_results: 'Aucune table nommée « {{text}} ».',
  },
  load_failed: {
    title: 'Impossible de charger les tables.',
    retry: 'Réessayer',
  },
  empty: {
    title: 'Aucune table pour l’instant',
    text: 'Ajoutez vos tables ci-dessus pour obtenir un lien et un QR code pour chacune. Les clients ne peuvent pas commander à table tant que vous n’en avez pas ajouté.',
  },
  delete: {
    title: 'Supprimer la table « {{name}} » ?',
    warning:
      'Les QR codes imprimés de cette table cesseront de fonctionner. Les clients qui en scannent un sont invités à s’adresser au personnel.',
    softer: 'Pour suspendre les commandes à cette table, désactivez-la plutôt.',
    confirm: 'Supprimer la table',
    cancel: 'Annuler',
  },
  announcements: {
    moved: '« {{name}} » déplacée à la position {{position}} sur {{count}}.',
    instructions: 'Pour déplacer une table, placez le focus sur sa poignée et appuyez sur la flèche haut ou bas.',
  },
  qr_image: {
    table: 'Table',
  },
  toasts: {
    added: 'Table « {{name}} » ajoutée',
    renamed: '« {{old}} » renommée en « {{name}} »',
    deleted: 'Table « {{name}} » supprimée',
    switched_on: '« {{name}} » activée',
    switched_off: '« {{name}} » désactivée',
    failed_to_save: 'L’enregistrement a échoué. Veuillez réessayer.',
    failed_to_reorder: 'Le nouvel ordre n’a pas été enregistré. Veuillez réessayer.',
    failed_to_download_qr: 'Impossible d’enregistrer le QR code. Veuillez réessayer.',
    copy_failed: 'Impossible de copier le lien. Veuillez réessayer.',
  },
};
